import { render, staticRenderFns } from "./SalaryExpectationsComment.vue?vue&type=template&id=415e26cd"
import script from "./SalaryExpectationsComment.vue?vue&type=script&lang=js"
export * from "./SalaryExpectationsComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports